import { InspectionsClient } from "./inspections.js";
import { ClientBase } from "./base.js";
export class OpsClient extends InspectionsClient {
    async setOpsResourcePhase(slug, resourceId, phase) {
        return this.request("PUT", `${this.siteBase(slug)}/ops/resources/${encodeURIComponent(resourceId)}`, { phase }, true);
    }
    /** `from`/`to` are RFC3339; `to` must be after `from`. */
    async listOpsSlots(slug, params) {
        const res = await this.request("GET", `${this.siteBase(slug)}/ops/slots${ClientBase.query(params)}`, undefined, true);
        return res.slots;
    }
    async reserveOpsSlot(slug, input) {
        return this.request("POST", `${this.siteBase(slug)}/ops/slots`, input, true);
    }
    async reserveOpsRecurring(slug, input) {
        const res = await this.request("POST", `${this.siteBase(slug)}/ops/recurring-blocks`, input, true);
        return res.slots;
    }
    async listOpsCredentials(slug, staffId) {
        const res = await this.request("GET", `${this.siteBase(slug)}/ops/credentials${ClientBase.query({ staffId })}`, undefined, true);
        return res.credentials;
    }
    async putOpsCredential(slug, input) {
        return this.request("POST", `${this.siteBase(slug)}/ops/credentials`, input, true);
    }
    async deleteOpsCredential(slug, id) {
        await this.request("DELETE", `${this.siteBase(slug)}/ops/credentials/${encodeURIComponent(id)}`, undefined, true);
    }
    /** Rejects with 409 when the credential is missing/expired or clearance is absent. */
    async checkOpsDispense(slug, input) {
        return this.request("POST", `${this.siteBase(slug)}/ops/dispense-check`, input, true);
    }
    async recordHeadcountTrueUp(slug, bookingId, input) {
        return this.request("POST", `${this.siteBase(slug)}/ops/bookings/${encodeURIComponent(bookingId)}/headcount-trueup`, input, true);
    }
    async listHeadcountTrueUps(slug, bookingId) {
        const res = await this.request("GET", `${this.siteBase(slug)}/ops/bookings/${encodeURIComponent(bookingId)}/headcount-trueups`, undefined, true);
        return res.trueUps;
    }
    async listOpsStockLots(slug) {
        const res = await this.request("GET", `${this.siteBase(slug)}/ops/stock-lots`, undefined, true);
        return res.lots;
    }
    async putOpsStockLot(slug, input) {
        return this.request("POST", `${this.siteBase(slug)}/ops/stock-lots`, input, true);
    }
    async recordOpsStockLotSale(slug, lotId, units) {
        return this.request("POST", `${this.siteBase(slug)}/ops/stock-lots/${encodeURIComponent(lotId)}/sales`, { units }, true);
    }
    async getConsignmentSettlement(slug) {
        return this.request("GET", `${this.siteBase(slug)}/ops/consignment-settlement`, undefined, true);
    }
    /** Records the settlement only; paying the consignor is an owner step. */
    async settleConsignment(slug, lotId) {
        const res = await this.request("POST", `${this.siteBase(slug)}/ops/consignment-settlement`, { lotId }, true);
        return res.settlements;
    }
}
//# sourceMappingURL=ops.js.map